import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageVO,} from '@models/index';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        SmsMenuPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import * as Const_SMS011 from '@pages/sms011-error/sms011-error-const';
import {SMS011ErrorInVO,} from '@pages/sms011-error/sms011-error-in-vo';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms011-error',
  templateUrl: './sms011-error.html',
  styleUrls: ['./sms011-error.scss',],
})
/*****************************************************/
/* 処　理：SMS011 エラー 画面
/*
/* 概　要：エラー情報表示 処理
/*
/* 更新日：2025/04/04 HARAGU 00011_SMS機能等の導入支援_10141
/*****************************************************/
export class SMS011Error implements OnInit {
  smsForm!: FormGroup;            // 画面フォーム
  loginUserVO!: LoginUserVO;      // セッション情報
  sms011InfoVO!: SMS011ErrorInVO; // POSTパラメータ情報
  dispId!: string;                // ログ表示用ID

  // POSTパラメータ格納用
  hashId!: string;                // ハッシュID
  menuNo!: string;                // 取引メニュー番号
  lngType!: string;               // 言語区分
  msgId!: string;                 // メッセージID

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // ボタン表示・非表示 設定用
  btnMenuVisibility = 'visible';

  // 画面項目（ラベル入れ替え用）
  public lblMessage01!: string;
  public lblMessage02!: string;
  public lblMessage03!: string;
  public lblTel01!: string;
  public lblTel02!: string;
  public lblSubmit!: string;
  public lblBtnMenu!: string;

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private smsMenuPage: SmsMenuPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {

    const postVo: SMS011ErrorInVO = this.windowService.getItemFromLocalStorage<SMS011ErrorInVO>('SMS011')!;
    if (postVo) {
      // POSTパラメータを取得
      this.sms011InfoVO = postVo;

      // POSTパラメータの値を設定
      this.hashId = this.sms011InfoVO?.hashId;
      this.menuNo = this.sms011InfoVO?.menuNo;
      this.lngType = this.sms011InfoVO.languageType;
      this.sms011InfoVO.messageStack.messages.forEach((message: MessageVO) => {
        this.msgId = message.messageId;
      })

      // ログ表示用IDセット
      this.dispId = this.sms011InfoVO.hashId;

    } else {

      // エラーログ出力
      this.logger.error('SMS01101M003E');

      // POSTパラメータの値を設定
      this.hashId = '';
      this.menuNo = '';
      this.lngType = this.constant.DEFAULT_LANGUAGE_TYPE;
      this.msgId = '';

      // ログ表示用IDセット
      this.dispId = '';
    }

    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {
      // ログイン情報を取得
      this.loginUserVO = connVo;

      // 契約情報IDが取得出来た場合は、上書き
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
    });

    // 初期表示
    this.formInit();
  }

  /**
   * 初期表示
   */
  formInit(): void {

    try {
      // ログ出力
      this.logger.info('SMS01101M001I', this.dispId, Const_SMS011.INIT_NAME);

      // ログ出力（POSTパラメータ）
      this.logger.debug(this.dispId + ' ■ 11 POSTパラメータ');
      this.logger.debug(this.dispId + ' ■ 11  hashId       ：' + this.hashId);
      this.logger.debug(this.dispId + ' ■ 11  languageType ：' + this.lngType);
      this.logger.debug(this.dispId + ' ■ 11  menuNo       ：' + this.menuNo);
      this.logger.debug(this.dispId + ' ■ 11  msgId        ：' + this.msgId);

      // ログ出力（POSTパラメータ）
      this.logger.info('SMS01101M004I', this.dispId, this.msgId);

      // メッセージIDを言語区分で切り替え（サーバー側では、日本語のIDのみ設定するため）
      const code: string[] = [];
      code[1] = this.msgId.substring(0, 6);
      code[2] = this.msgId.substring(8, 13);
      this.msgId = code[1] + this.lngType + code[2];

      // タイトル設定
      let titleId!: string;
      let bushoFlg!: string;
      switch (this.msgId) {
        case 'SMS999' + this.lngType + 'M001E': titleId = 'SMS999' + this.lngType + 'M001M'; bushoFlg = '0'; break; // お客様の情報が取得できませんでした
        case 'SMS999' + this.lngType + 'M002E': titleId = 'SMS999' + this.lngType + 'M002M'; bushoFlg = '1'; break; // ３回入力を間違えました
        case 'SMS999' + this.lngType + 'M003E': titleId = 'SMS999' + this.lngType + 'M003M'; bushoFlg = '0'; break; // 本人確認ができませんでした。
        case 'SMS999' + this.lngType + 'M004E': titleId = 'SMS999' + this.lngType + 'M004M'; bushoFlg = '0'; break; // リフレッシュトークン期限切れ
        case 'SMS999' + this.lngType + 'M005E': titleId = 'SMS999' + this.lngType + 'M005M'; bushoFlg = '0'; break; // 請求額未確定
        case 'SMS999' + this.lngType + 'M006E': titleId = 'SMS999' + this.lngType + 'M006M'; bushoFlg = '0'; break; // 解約日を設定できません
        case 'SMS999' + this.lngType + 'M007E': titleId = 'SMS999' + this.lngType + 'M007M'; bushoFlg = '0'; break; // お客様の情報が更新できませんでした
        case 'SMS999' + this.lngType + 'M008E': titleId = 'SMS999' + this.lngType + 'M008M'; bushoFlg = '0'; break; // バーコードの払出しに失敗しました
        case 'SMS999' + this.lngType + 'M009E': titleId = 'SMS999' + this.lngType + 'M009M'; bushoFlg = '1'; break; // 手続できません
        case 'SMS999' + this.lngType + 'M010E': titleId = 'SMS999' + this.lngType + 'M010M'; bushoFlg = '0'; break; // バーコード支払できません
        case 'SMS999' + this.lngType + 'M011E': titleId = 'SMS999' + this.lngType + 'M011M'; bushoFlg = '0'; break; // 入力内容をご確認ください
        case 'SMS999' + this.lngType + 'M012E': titleId = 'SMS999' + this.lngType + 'M012M'; bushoFlg = '0'; break; // 画面を表示できませんでした
        case 'SMS999' + this.lngType + 'M013E': titleId = 'SMS999' + this.lngType + 'M013M'; bushoFlg = '1'; break; // 予期せぬエラーが発生しました
        case 'SMS999' + this.lngType + 'M014E': titleId = 'SMS999' + this.lngType + 'M014M'; bushoFlg = '1'; break; // ただいまメンテナンス中です
        default:
          this.logger.debug(this.dispId + ' ■ 11 パターン外メッセージ');

          // 上記以外(ICS定義のメッセージ等)の場合、予期せぬエラーとして画面表示
          titleId = 'SMS999' + this.lngType + 'M013M';
          this.msgId = 'SMS999' + this.lngType + 'M013E';
          bushoFlg = '1';
          break;
      }

      // 画面文言（言語区分により変換）
      // メッセージタイトル
      this.lblMessage01 = this.messageProvider.getMessageString({messageId: titleId,},  false) || '';
      // メッセージ本文（エラー内容）
      this.lblMessage02 = this.messageProvider.getMessageString({messageId: this.msgId,},  false) || '';

      // 電話番号表示有りの場合
      if ('1' === bushoFlg) {
        this.logger.debug(this.dispId + ' ■ 11 電話番号表示有り');

        // 担当部署：
        this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS011' + this.lngType + 'M001F',},  false) || '';
        // tel:0570030660（リンク文字）
        this.lblTel01 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M004F',},  false) || '';
        // 0570-030-660
        this.lblTel02 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M003F',},  false) || '';
      }

      // メニューへ戻る
      this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS011' + this.lngType + 'M002F',},  false) || '';

      // ブラウザ・ヘッダータイトル
      const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
      this.titleService.setTitle(companyName);
      document.getElementById('lblScreenTitle')!.innerText = '';

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS01101M002I', this.dispId, Const_SMS011.INIT_NAME);

      // 初期化（ログイン情報）
      this.windowService.removeItemFromLocalStorage('accToken');
      this.windowService.removeItemFromLocalStorage('loginInfo');

    } catch (ex) {
      this.logger.error('SMS01101M001E', this.dispId, Const_SMS011.INIT_NAME);
      this.commonException(ex);

      // 予期しないエラー発生時は、固定文字出力
      this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M013M',},  false) || '';
      this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M013E',},  false) || '';
      this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS011' + this.lngType + 'M001F',},  false) || '';
      this.lblTel01 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M004F',},  false) || '';
      this.lblTel02 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M003F',},  false) || '';
      this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS011' + this.lngType + 'M002F',},  false) || '';

    } finally {
      // POSTパラメータ情報が取得出来ない場合、メインメニューに戻れないため「メニューに戻る」ボタンを非表示
      if (this.stringUtil.isEmpty(this.hashId)) {
        this.logger.debug(this.dispId + ' ■ 11 「メニューに戻る」ボタンを非表示');
        this.btnMenuVisibility = 'hidden';
      }
    }
  }


  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS01101M003I', this.dispId, Const_SMS011.BTN_BACKMENU_NAME);

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.sms011InfoVO.hashId,
                                  this.sms011InfoVO.menuNo,
                                  this.sms011InfoVO.languageType);

    } catch (ex) {
      this.logger.error('SMS01101M002E', this.dispId, Const_SMS011.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 11 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }
  }
}
